export default "__VITE_PUBLIC_ASSET__4224803d__"